/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/delivery'>.
 * exact
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Delivery from '@routes/Delivery';

export const Route = createFileRoute('/delivery/')({
  component: () => <CacheDataRoute component={Delivery} path='/delivery' />
});
